<template>
	<div class="mode-theme-settings">
		<div class="toggleWrapper">
			<input type="checkbox" class="dn" id="dn" @click="switchMode()" />
			<label for="dn" class="toggle">
				<span class="toggle__handler">
					<span class="crater crater--1"></span>
					<span class="crater crater--2"></span>
					<span class="crater crater--3"></span>
				</span>
				<span class="star star--1"></span>
				<span class="star star--2"></span>
				<span class="star star--3"></span>
				<span class="star star--4"></span>
				<span class="star star--5"></span>
				<span class="star star--6"></span>
			</label>
		</div>
		<div class="mode-theme-settings__white-label">
			<label class="theme-switch__label" for="brand-select"
				>White-label:
			</label>
			<select
				id="brand-select"
				v-model="dealershipGroupId"
				@change="switchBrand()"
			>
				<option value="" selected>Dealership Group...</option>
				<option
					v-for="dealershipGroup in brandingArray"
					:key="dealershipGroup.id"
					:value="dealershipGroup.id"
					>{{ dealershipGroup.name }}</option
				>
			</select>
			<select
				id="company-select"
				v-model="companyId"
				@change="switchCompany()"
				v-if="companies"
			>
				<option value="0" selected>Company...</option>
				<option
					v-for="company in companies"
					:key="company.id"
					:value="company.id"
					>{{ company.name }}</option
				>
			</select>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'ModeToggle',
	data() {
		return {
			activeMode: 'light',
			dealershipGroupId: '',
			companyId: 0
		};
	},
	created() {
		this.getBrandingAction();
	},
	computed: {
		...mapGetters('branding', ['brandingArray', 'brand', 'company']),
		companies() {
			var companies;

			if (this.brand) {
				companies = this.brand.companies;
			}

			return companies;
		}
	},
	methods: {
		...mapActions('branding', [
			'getBrandingAction',
			'setBrandAction',
			'setCompanyAction',
			'setMode'
		]),
		switchMode() {
			if (this.activeMode === 'light') {
				this.activeMode = 'dark';
			} else {
				this.activeMode = 'light';
			}
			this.setMode(this.activeMode);
		},
		switchBrand() {
			this.setBrandAction(this.dealershipGroupId);
			this.companyId = 0;
			this.switchCompany();
		},
		switchCompany() {
			this.setCompanyAction(this.companyId);
		}
	}
};
</script>

<style lang="scss" scoped>
.mode-theme-settings {
	z-index: $z-level6;
	position: fixed;
	background: #e8e8e8;
	color: #333;
	padding: 8px;
	left: 0;
	box-shadow: 4px 3px 5px 0 rgb(130 130 130 / 50%);
	border-radius: 4px 4px 0 0;
	text-align: center;
	left: 50%;
	bottom: 0;
	transform: translateX(-50%);

	&__white-label {
		margin-top: 4px;
		display: inline-flex;
		align-items: center;
		font-size: 12px;
	}

	.theme-switch {
		// Use this transform for custom sized toggle
		transform: scale(0.6);

		display: flex;
		align-items: center;
		input {
			display: none;
		}
		label {
			display: block;
			height: 36px;
			width: 62px;
			border-radius: 50px;
			background: #333;
			cursor: pointer;
			transition: 0.2s;

			&:before {
				content: '';
				position: absolute;
				top: 4px;
				left: 5px;
				height: 28px;
				width: 28px;
				background: white;
				border-radius: 50%;
				border-radius: 16px;
				z-index: $z-level1-1;
				animation: off 0.5s ease-out;
				transform-origin: 0 0;
			}
		}

		input:checked + label {
			background: green;

			&:before {
				transform: translateX(26px);
				animation: on 0.5s ease-out;
				transform-origin: 100% 0;
				background: white;
			}
		}
	}

	//****Toggle Light/Dark Mode ****/
	.toggleWrapper {
		overflow: hidden;
		padding: 0 55px;
		transform: scale(0.65);
		text-align: left;

		input {
			position: absolute;
			left: -99em;
		}
	}

	.toggle {
		cursor: pointer;
		display: inline-block;
		position: relative;
		width: 90px;
		height: 50px;
		background-color: #83d8ff;
		border-radius: 90px - 6;
		transition: background-color 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);

		&:before {
			content: 'Light';
			position: absolute;
			left: -50px;
			top: 15px;
			font-size: 18px;
		}

		&:after {
			content: 'Dark';
			position: absolute;
			right: -48px;
			top: 15px;
			font-size: 18px;
			color: #749ed7;
		}
	}

	.toggle__handler {
		display: inline-block;
		position: relative;
		z-index: $z-level1-1;
		top: 3px;
		left: 3px;
		width: 50px - 6;
		height: 50px - 6;
		background-color: #ffcf96;
		border-radius: 50px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
		transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
		transform: rotate(-45deg);

		.crater {
			position: absolute;
			background-color: #e8cda5;
			opacity: 0;
			transition: opacity 200ms ease-in-out;
			border-radius: 100%;
		}

		.crater--1 {
			top: 18px;
			left: 10px;
			width: 4px;
			height: 4px;
		}

		.crater--2 {
			top: 28px;
			left: 22px;
			width: 6px;
			height: 6px;
		}

		.crater--3 {
			top: 10px;
			left: 25px;
			width: 8px;
			height: 8px;
		}
	}

	.star {
		position: absolute;
		background-color: #ffffff;
		transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
		border-radius: 50%;
	}

	.star--1 {
		top: 10px;
		left: 35px;
		z-index: $z-level1;
		width: 30px;
		height: 3px;
	}

	.star--2 {
		top: 18px;
		left: 28px;
		z-index: $z-level1-1;
		width: 30px;
		height: 3px;
	}

	.star--3 {
		top: 27px;
		left: 40px;
		z-index: $z-level1;
		width: 30px;
		height: 3px;
	}

	.star--4,
	.star--5,
	.star--6 {
		opacity: 0;
		transition: all 300ms 0 cubic-bezier(0.445, 0.05, 0.55, 0.95);
	}

	.star--4 {
		top: 16px;
		left: 11px;
		z-index: $z-level1;
		width: 2px;
		height: 2px;
		transform: translate3d(3px, 0, 0);
	}

	.star--5 {
		top: 32px;
		left: 17px;
		z-index: $z-level1;
		width: 3px;
		height: 3px;
		transform: translate3d(3px, 0, 0);
	}

	.star--6 {
		top: 36px;
		left: 28px;
		z-index: $z-level1;
		width: 2px;
		height: 2px;
		transform: translate3d(3px, 0, 0);
	}

	input:checked {
		+ .toggle {
			background-color: #749dd6;

			&:before {
				color: #749ed7;
			}

			&:after {
				color: #333;
			}

			.toggle__handler {
				background-color: #ffe5b5;
				transform: translate3d(40px, 0, 0) rotate(0);

				.crater {
					opacity: 1;
				}
			}

			.star--1 {
				width: 2px;
				height: 2px;
			}

			.star--2 {
				width: 4px;
				height: 4px;
				transform: translate3d(-5px, 0, 0);
			}

			.star--3 {
				width: 2px;
				height: 2px;
				transform: translate3d(-7px, 0, 0);
			}

			.star--4,
			.star--5,
			.star--6 {
				opacity: 1;
				transform: translate3d(0, 0, 0);
			}
			.star--4 {
				transition: all 300ms 200ms
					cubic-bezier(0.445, 0.05, 0.55, 0.95);
			}
			.star--5 {
				transition: all 300ms 300ms
					cubic-bezier(0.445, 0.05, 0.55, 0.95);
			}
			.star--6 {
				transition: all 300ms 400ms
					cubic-bezier(0.445, 0.05, 0.55, 0.95);
			}
		}
	}
}
</style>
